export const hotelReservation: any = {
  status: {
    arranged: "予約済み",
    cancelled: "キャンセル済み",
  },
};
